const disciplines = [
  { text: 'IDEAS', style: 'ticker-logo-bold' },
  { text: 'STRATEGY', style: 'ticker-logo-light' },
  { text: 'AI', style: 'ticker-logo-bold' },
  { text: 'DESIGN', style: 'ticker-logo-wide' },
  { text: 'CRAFT', style: 'ticker-logo-light' },
  { text: 'VENTURES', style: 'ticker-logo-bold' },
  { text: 'EXECUTION', style: 'ticker-logo-wide' },
  { text: 'SYSTEMS', style: 'ticker-logo-light' },
];

const SEPARATOR = () => (
  <span className="ticker-sep" aria-hidden="true">/</span>
);

function DisciplineRow() {
  return (
    <>
      {disciplines.map((d, i) => (
        <span key={i} className="ticker-partner-wrap">
          <span className={`ticker-partner ${d.style}`}>{d.text}</span>
          <SEPARATOR />
        </span>
      ))}
    </>
  );
}

export default function Ticker() {
  return (
    <div className="ticker-wrap" aria-hidden="true" data-testid="ticker">
      <div className="ticker-track">
        <DisciplineRow />
        <DisciplineRow />
      </div>
    </div>
  );
}
